import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

// Necesarios para utilizar Observable
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';

// Interface con los datos que devuelve el API
import { HttpClient, HttpParams } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { IAuthorized } from '../model/authorized';
import { IPerson } from '../model/person';
import { IInvoicingService } from '../model/invoicing-service';
import { IPlatform } from '../model/platform';

/**
 * Servicio de gestion de autorizados
 */
@Injectable()
export class AuthorizedService {
  private authorizedServiceUrl = environment.apiUrl + '/v1/invoicing-services/';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService
  ) { }


  /**
   *
   * @param {IAuthorized} authorized
   * @return {Observable<any>}
   */
  saveAuthorized(authorized: IAuthorized): Observable<any> {
    this.spinnerService.setSpinner(true);
    const url = this.authorizedServiceUrl + `${authorized.person.identifier}/authorizeds`;
    return this.http.post(url, authorized)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {IPerson} person
   * @return {Observable<IAuthorized[]>}
   */
  getAuthorizeds(person: IPerson): Observable<IAuthorized[]> {
    this.spinnerService.setSpinner(true);
    const url = this.authorizedServiceUrl + `${person.identifier}/authorizeds`;
    return this.http.get<IAuthorized[]>(url)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IAuthorized[];
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param person
   * @param authorized
   */
  deleteAuthorized(person: IPerson, authorized: IAuthorized) {
    this.spinnerService.setSpinner(true);
    const url = this.authorizedServiceUrl + `${person.identifier}/authorizeds/${authorized.id}`;
    return this.http.delete(url)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/authorized.service.ts